import React from 'react';
import { SignInPage } from 'scenes/auth/pages/SignInPage';
import { Page } from 'shared/components/Page';

export const AuthRoutes: React.FC = (): JSX.Element => {
  return (
    <Page windowTitle="">
      <SignInPage />
    </Page>
  );
};
